/* eslint-disable no-debugger*/
import {useState, useEffect, useRef} from "react";
import {useNavigate} from "react-router-dom";
import {ModifiedToast} from "./toaster";
import {Helmet, HelmetProvider} from "react-helmet-async";
import {useSendOtpMutation, useSignupUserMutation} from "../services/authApi";
import OtpInput from "react-otp-input";
import { ToastContainer, toast } from "react-toastify";
import {useDispatch} from "react-redux";
// import { userInfo } from "../redux/AuthSlice/authSlice";
import { openJoyce } from "../redux/JoyiceSlice/joyiceSlice";


const Otp = () => {
  const navigate = useNavigate();
  const [ otp, setOtp ] = useState("");
  const dispatch = useDispatch();
  const [ formData, setFormData ] = useState(JSON.parse(localStorage.getItem('registration_data')) ?? {});
  const [ otpId ] = useState(JSON.parse(localStorage.getItem('otp_data')).data.id ?? 0);
  
  useEffect(() => {
    setTimeout(() => {
      if(otpId){
        setFormData({...formData, otpId: otpId ?? 0});
      }else{
        window.location.href = '/';
      }
      
    }, 200);
    
    const accessToken = localStorage.getItem('accessToken');
    if (accessToken) {
      navigate('/dashboard');
    }
    console.log(formData);
  }, []);

  const [ signupUser, { data,
     isLoading, isError, isSuccess, error:apiError
     } ] =
    useSignupUserMutation();
    const [ sendOtp, {data:otpData, isSuccess:isOtpSuccess } ] = useSendOtpMutation();
    const toastId = useRef(null);
    useEffect(() => {
      if (isLoading) {
        toastId.current = toast.loading("Please wait...", {
        position: "top-right",
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        theme: "colored",
        type: "info"
      });
      }
      if (isSuccess) {
        toast.update(
          toastId.current,
          ("Your account has been created successfully.",
          {
            render: "Your account has been created successfully.",
            type: "success",
            autoClose: 2000,
            isLoading: false
          })
        );
        localStorage.setItem('accessToken', data.accessToken);
        localStorage.setItem("loggedInUser", JSON.stringify(data));
        setTimeout(() => {
          // dispatch(openJoyce({isJoyce:true, isSignup:true, data:data}));
          // dispatch(userInfo(data));
          window.location.href = "/dashboard";
        }, 100);
        
      }
      if (isError){
        const toastMessage = apiError?.data?.message
          ? apiError?.data?.message
          : "Something went wrong";
        toast.update(
          toastId.current,
          (toastMessage,
          {
            render: toastMessage,
            type: "error",
            autoClose: 4000,
            isLoading: false
          })
        );           
      }
    }, [ isSuccess, isError, isLoading ]);

  useEffect(() => {
    if (isOtpSuccess) {
      setFormData({...formData, otpId: otpData?.data?.id});
    }
  }, [ isOtpSuccess ]);

  useEffect(() => {
    setFormData({...formData, otpId: otpId});
    setFormData({ ...formData, otp: otp });
  }, [ otp ]);

  const handelRegisterSubmit = () => {
    signupUser(formData);
    dispatch(openJoyce({isJoyce:false, isSignup:false}));
  };

  const handleResendOTP = () => {
    let value = {
      "mobile": `${formData.mobileNo}`,
      "country_code": `${formData.countryCode}`,
      "email":`${ formData.email}`
    };
    sendOtp(value);
  }


  return (
    <div className=" h-screen	flex bg-gray-bg1 w-full">
      <HelmetProvider>
        <Helmet>
          <title>Simplyenglish AI | Verify OTP </title>
        </Helmet>
      </HelmetProvider>
      <ToastContainer />
      <ModifiedToast />
      <div className=" flex align-center w-full signupPage">
        <div className=" w-full bg-white ">
          <div className="md:flex align-center justify-between h-full items-center flex-wrap md:flex-nowrap     ">
            <div className=" md:p-8 p-2 md:w-1/2 w-full relative">
              <div className=" pt-0">
                <div className="w-full max-w-lg m-auto bg-white lg:p-8 py-5 p-4 pt-2 border shadow-lg rounded-lg ">
                  <div className="text-left" id="otpForm" >
                  <div className="content text-center ">
                      <div className="">
                        <h2 className="text-2xl ">OTP Verification</h2>
                        <p className=" mt-3 mb-6">
                          We have sent you a verification code on your
                          registered email.
                        </p>
                        <h3 className="text-base">
                          {formData.email}
                        </h3>
                      </div>
                      <div className=" mx-auto  mt-3 otpSection">
                        <OtpInput
                          className="w-full"
                          value={otp}
                          onChange={setOtp}
                          numInputs={4}
                          renderInput={(props) => (
                            <input {...props} className="otpInput" />
                          )}
                        />
                      </div>
                      <center>
                      <button className="resend  px-4 py-2 rounded my-4 font-bold secondry-text "
                      onClick={(e) => handleResendOTP(e)}>
                        Resend
                      </button>
                      </center>
                     
                    
                      <div className="lg:w w-full  ">
                        <div className="w-full ">
                          <div className="form-group  flex justify-center ">
                          <button
                            className="btn save w-full"
                            aria-describedby="popup-8"
                            onClick={handelRegisterSubmit}
                          >
                            Continue
                          </button>

                          </div>
                        </div>
                      </div>

                    </div>
                  </div>
                  </div>
                  </div>
                  </div>
                    </div>
                    <ModifiedToast />
                  </div>
                </div>
            <div className=" md:w-1/2 md:h-full flex flex-wrap  md:flex hidden  justify-center relative ">
              <div className="loginImage bg-white w-full">
                <div className="text-center w-full  px-12 mb-6 mt-2 ">
                  <img
                    src="./images/logo.png"
                    width="270"
                    className="mx-auto mb-4"
                  />
                </div>
                <img src="./images/login.jpg" className="userImage" />
              </div>
            </div>
          </div>
  );
};

export default Otp;
